<div class="wccard p-3 mb-1">
    <app-talent-insights-ai [jobDemandCount]="hasJobDemand" [requestaidata]="jobtitledataAI" [insightstabname]="'titles'" [totalcount]="totalResultCount" [dataPending] = "getDataPendingStatus()"></app-talent-insights-ai>
</div>
<!-- titles -->
<div class="wccard p-3 mb-1">

    <p class="f-16 font-weight-600 mb-5">What are the most common titles among this talent?</p>

    <div>

    <div *ngIf="!currentjobtitles?.data?.length">
        <div class="loader text-center" *ngIf="!isApiCalled">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="isApiCalled">
            <p class="text-center small p-5">No Data Available</p>
        </div>
    </div>
    <div class="mt-2" *ngIf="currentjobtitles?.data?.length">
            <table mat-table [dataSource]="currentjobtitles" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort #titlesort="matSort"  (matSortChange)="manualSort()">

                <!-- key -->
                <ng-container matColumnDef="key">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-3">
                        <p class="text-9696 f-12 m-0">{{tableHeaderObj['Titles']}} </p>
                    </th>
                    <td class="" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                      <div class="d-flex">
                            <div class="f-14 text-484b59">{{element.key | titlecase}}</div>
                      </div>

                    </td>
                </ng-container>

                <!-- doc_count -->
                <ng-container matColumnDef="doc_count">
                    <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by doc_count">
                        <p class="text-9696 f-12 m-0"> {{tableHeaderObj['TalentCount']}} </p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <span class="pointer"  (click)="handelRedirection('jobtitle', element.key)">{{element.doc_count | number}}</span>
                    </td>
                </ng-container>

             <!-- %Total tenure -->
             <ng-container matColumnDef="totalTenure">
                <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                sortActionDescription="Sort by tenure">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['MedianOverallExp']}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 f-12">
                    {{element.total_tenure != 0 ? getFormattedTenure(element.total_tenure): '0'}}
                </td>
            </ng-container>


              <ng-container matColumnDef="job_doc_count">
                <th class=""  *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand" >{{tableHeaderObj['JobDemand']}}</p>
                         <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
<span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess && openJoblistSlider('jobtitles', element.key)" [class.pointer]="hasJobListingAccess">{{element?.job_doc_count | number}}</span>
          <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
                </td>
            </ng-container>

             <ng-container matColumnDef="median_salary">
                <th class=""  *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0"  ><span [ngbTooltip]="mediansalarytooltip">{{tableHeaderObj['MedianSalary']}}</span>
                        <span class="dropdown ats-dropBtn ml-2">

              <span class="dropdown-toggle text-webbtree-green f-14" type="button" id="userDropdownButton" (click)="clearCurrencyInput('title')"
                appDropdownToggle><i class="fa-solid {{target_fav_icon}}" *ngIf="target_fav_icon != 'fa-money-bill'"></i>
                {{target_fav_icon == 'fa-money-bill' ? currency : ''}}
                <span class="down ml-1"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
</span>
              <span class="dropdown-menu" aria-labelledby="userDropdownButton"
                style="width: -webkit-fill-available; padding: 10px;">
                <div class="search-input">
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>

                  <input data-testid="auto-app-report-titles-input-1" class="wc-form-control no-shadow w-100 inputheight mb-0 mt-0 mx-0" placeholder="Currency"
                     [(ngModel)]="currency" (keyup)="onTypeAheadSearch($event)"
                    (keydown.tab)="handleTabOpen($event)" />
                </div>

                <div *ngIf="filteredCurrencies?.length">
                  <span class="dropdown-item pointer d-flex align-items-center f-14 font-weight-400"
                    *ngFor="let cl of filteredCurrencies" (click)="selectedItem(cl, 'title')"
                    style="padding: 10px 10px!important;">
                    {{ cl.target_currency }}
                  </span>
                </div>
              </span>
            </span>
               <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600 mb-1">About Salary Estimates</p>
                      <p class="f-12 mb-1">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                    </p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                   <div *ngIf="hasMedianSalary" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    <span *ngIf="element?.median_salary != 'N/A'" class="" [innerHTML]="element.median_salary" >
                      <span *ngIf="element?.confidence_score == 'very high' || element?.confidence_score == 'high'" matTooltip='{{element?.confidence_score | titlecase}} confidence'
            [matTooltipClass]="{ 'big-tooltip text-black': true }"><i class="fa-sharp fa-solid fa-shield-check ml-1" style="color: #2E93A1;"></i></span></span>
                  <span *ngIf="element?.median_salary == 'N/A'" matTooltip='We’re actively expanding salary coverage for this role. More data will be available as market signals strengthen.'
                  [matTooltipClass]="{ 'big-tooltip text-black': true }" style="font-family: Arial, sans-serif;">&mdash;</span>

                </td>
            </ng-container>

                 <ng-container matColumnDef="topemployers">
                <th mat-header-cell mat-header-cell *matHeaderCellDef
                    class="col-2">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['TopEmployers']}}</p>
                </th>
                <td class="col-2" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;" >
                  <div class="d-flex">
                    <div *ngIf="!hasTopEmployer" class="spinner-border position-absolute text-black" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                        <div *ngIf="hasTopEmployer" class="f-14 text-484b59">{{element.companynames ? (element.companynames | titlecase ): 'NA'}}</div>
                  </div>

                </td>
            </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div *ngIf="currentjobtitles == null || currentjobtitles.length == 0">
                <p class="text-center small p-5">No Data Available</p>
            </div>
        </div>


    </div>
     <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
    <ngb-pagination [collectionSize]="totalCount <=50 ? totalCount : 50" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false"
    [boundaryLinks]="false" [directionLinks]="false">

    </ngb-pagination>
  </div>
  </div>

<!-- Functions -->
<div class="wccard p-3 mt-2 mb-1">
    <p class="f-16 mb-6 font-weight-600">Which functions does this talent work in?</p>
    <div *ngIf="!functions?.length">
        <div class="loader text-center" *ngIf="isFunctionPending">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isFunctionPending">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>


    <div class="mt-2" *ngIf="functionsdata?.data?.length">
        <table mat-table [dataSource]="functionsdata" class="mat-elevation-z8" style="width: 100%; box-shadow: none;"
            #functionsort="matSort" matSort (matSortChange)="manualfunctionsort()">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">{{functionTableHeaderObj.Function}}</p>
                </th>
                <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element?.key?.replaceAll("_", ' ') | titlecase}}
                </td>
            </ng-container>

            <!-- doc_count -->
            <ng-container matColumnDef="doc_count">
                <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="doc_count"
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">{{functionTableHeaderObj.TalentCount}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
                    <span class="pointer" (click)="handelRedirection('functions', element.key)">{{element.doc_count |
                        number}}</span>
                </td>
            </ng-container>

            <!-- Percentage of Total -->
            <ng-container matColumnDef="%total">
                <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">{{functionTableHeaderObj.PercentageOfTotal}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59">
                    {{getFunctionPercentage(element.doc_count) | number}}%
                </td>
            </ng-container>

            <!--Avg Tenure-->
            <ng-container matColumnDef="median_tenure">
                <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header="median_tenure"
                    sortActionDescription="Sort by avg tenure">
                    <p class="text-9696 f-12 m-0">{{functionTableHeaderObj.MedianTenure}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 f-12">
                    {{element.median_tenure != 0 ? getFormattedTenure(element.median_tenure): '0'}}
                </td>
            </ng-container>

            <!-- Job Demand -->
            <ng-container matColumnDef="job_doc_count">
                <th class="" *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">{{functionTableHeaderObj.JobDemand}}
                    </p>
                     <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                    <div *ngIf="isFunctionSalaryPending" class="spinner-border position-absolute text-black"
                        role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!isFunctionSalaryPending">
            <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess &&  openJoblistSlider('functions', element.key)" [class.pointer]="hasJobListingAccess">{{element?.job_doc_count | number}}</span>
          <span class=""  *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>

                    </div>
                </td>
            </ng-container>

            <!-- Median Salary -->
            <ng-container matColumnDef="median_salary">
                <th class="" *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="mediansalarytooltip">{{functionTableHeaderObj.MedianSalary}}
                        <span class="dropdown ats-dropBtn ml-2">

                            <span class="dropdown-toggle text-webbtree-green f-14" type="button"
                                id="userDropdownButtonFunction" (click)="clearCurrencyInput('function')"
                                appDropdownToggle><i class="fa-solid {{functionCurrencyData.target_fav_icon}}"
                                    *ngIf="functionCurrencyData.target_fav_icon != 'fa-money-bill'"></i>
                                {{functionCurrencyData.target_fav_icon == 'fa-money-bill' ?
                                functionCurrencyData.currency : ''}}
                                <span class="down ml-1"><i
                                        class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
                            </span>
                            <span class="dropdown-menu" aria-labelledby="userDropdownButtonFunction"
                                style="width: -webkit-fill-available; padding: 10px;">
                                <div class="search-input">
                                    <i class="fa-solid fa-magnifying-glass search-icon"></i>

                                    <input data-testid="auto-app-report-titles-input-2" class="wc-form-control no-shadow w-100 inputheight mb-0 mt-0 mx-0"
                                        placeholder="Currency" [(ngModel)]="functionCurrencyData.currency"
                                        (keyup)="onTypeAheadSearch($event)" (keydown.tab)="handleTabOpen($event)" />
                                </div>

                                <div *ngIf="filteredCurrencies?.length">
                                    <span class="dropdown-item pointer d-flex align-items-center f-14 font-weight-400"
                                        *ngFor="let cl of filteredCurrencies" (click)="selectedItem(cl, 'function')"
                                        style="padding: 10px 10px!important;">
                                        {{ cl.target_currency }}
                                    </span>
                                </div>
                            </span>
                        </span>
                        <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600">About Salary Estimates</p>
                      <p class="f-12">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                    </p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                    <div *ngIf="isFunctionSalaryPending" class="spinner-border position-absolute text-black"
                        role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <div *ngIf="!isFunctionSalaryPending">
                        <span *ngIf="element?.median_salary != 'N/A'" class=""
                            [innerHTML]="element.median_salary" ></span>
                        <span *ngIf="element?.confidence_score == 'very high' || element?.confidence_score == 'high'"
                            matTooltip='{{element?.confidence_score | titlecase}} confidence'
                            [matTooltipClass]="{ 'small-tooltip text-black': true }"><i
                                class="fa-sharp fa-solid fa-shield-check ml-1" style="color: #2E93A1;"></i></span>
                        <span *ngIf="element?.median_salary == 'N/A'"
                            matTooltip='We’re actively expanding salary coverage for this role. More data will be available as market signals strengthen.'
                            [matTooltipClass]="{ 'small-tooltip text-black': true }" style="font-family: Arial, sans-serif;">&mdash;</span>

                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedfunctionsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedfunctionsColumns;"></tr>
        </table>
    </div>
    <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCountFunction > 5">
        <ngb-pagination [collectionSize]="totalCountFunction" [maxSize]="5" aria-label="Custom pagination"
            [pageSize]="pageSizeFunction" rotate="false" (pageChange)="setPageFunction($event)"
            [(page)]="currentFunctionPage" [ellipses]="false" [boundaryLinks]="false" [directionLinks]="false">
        </ngb-pagination>
    </div>
</div>



<!-- Seniority -->
  <div class="wccard p-3 mb-1">

    <p class="f-16 font-weight-600 mb-5">Seniority</p>

    <div>

    <div *ngIf="!currentseniority?.data?.length">
        <div class="loader text-center" *ngIf="isSeniorityApiCalled">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="!isSeniorityApiCalled">
            <p class="text-center small p-5">No Data Available</p>
        </div>
    </div>
    <div class="mt-2" *ngIf="currentseniority?.data?.length">
            <table mat-table [dataSource]="currentseniority" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort #senioritySort="matSort"  (matSortChange)="manualSortSeniority()">

                <!-- key -->
                <ng-container matColumnDef="key">
                    <th mat-header-cell mat-header-cell *matHeaderCellDef class="col-3">
                        <p class="text-9696 f-12 m-0">{{senioritytableHeaderObj['Title']}} </p>
                    </th>
                    <td class="" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                      <div class="d-flex">
                            <div class="f-14 text-484b59">{{element.key | titlecase}}</div>
                      </div>

                    </td>
                </ng-container>

                <!-- doc_count -->
                <ng-container matColumnDef="doc_count">
                    <th class="col-3" mat-header-cell *matHeaderCellDef mat-sort-header
                        sortActionDescription="Sort by doc_count">
                        <p class="text-9696 f-12 m-0"> {{senioritytableHeaderObj['TalentCount']}} </p>
                    </th>
                    <td class="text-484b59 font-weight-600" mat-cell *matCellDef="let element">
                        <span class="" >{{element.doc_count | number}}</span>
                    </td>
                </ng-container>

             <!-- %Total tenure -->

              <ng-container matColumnDef="job_doc_count">
                <th class=""  *matHeaderCellDef mat-header-cell >
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">{{senioritytableHeaderObj['JobDemand']}}</p>
                          <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
<span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess && openJoblistSlider('seniority', element.key)" [class.pointer]="hasJobListingAccess">{{element?.job_doc_count | number}}</span>
          <span  class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>

                </td>
            </ng-container>

             <ng-container matColumnDef="median_salary">
                <th class=""  *matHeaderCellDef mat-header-cell>
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="mediansalarytooltip">{{senioritytableHeaderObj['MedianSalary']}}
                       <span class="dropdown ats-dropBtn ml-2">

              <span class="dropdown-toggle text-webbtree-green f-14" type="button" id="userDropdownButton" (click)="clearCurrencyInput('seniority')"
                appDropdownToggle><i class="fa-solid {{target_fav_icon_seniority}}" *ngIf="target_fav_icon_seniority != 'fa-money-bill'"></i>
                {{target_fav_icon_seniority == 'fa-money-bill' ? seniorityCurrency : ''}}
                <span class="down mr-2"><i class="far fa-angle-down font-weight-300 f-14 pointer"></i></span>
</span>
              <span class="dropdown-menu" aria-labelledby="userDropdownButton"
                style="width: -webkit-fill-available; padding: 10px;">
                <div class="search-input">
                  <i class="fa-solid fa-magnifying-glass search-icon"></i>

                  <input data-testid="auto-app-report-titles-input-3" class="wc-form-control no-shadow w-100 inputheight mb-0 mt-0 mx-0" placeholder="Currency"
                     [(ngModel)]="seniorityCurrency" (keyup)="onTypeAheadSearch($event)"
                    (keydown.tab)="handleTabOpen($event)" />
                </div>

                <div *ngIf="filteredCurrencies?.length">
                  <span class="dropdown-item pointer d-flex align-items-center f-14 font-weight-400"
                    *ngFor="let cl of filteredCurrencies" (click)="selectedItem(cl, 'seniority')"
                    style="padding: 10px 10px!important;">
                    {{ cl.target_currency }}
                  </span>
                </div>
              </span>
            </span>
                   <ng-template #mediansalarytooltip>
                      <p class="f-12 font-weight-600 mb-1">About Salary Estimates</p>
                      <p class="f-12 mb-1">Salary range is based on employer-declared compensation shared in job postings. This reflects market-reported averages and may not capture privately negotiated or undisclosed salary bands.</p>
                      <p class="f-12 mb-1">Salary and job post metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                    </p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                   <div *ngIf="hasMedianSalarySeniority" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    <span *ngIf="element?.median_salary != 'N/A'" class="" [innerHTML]="element?.median_salary" ></span>
                  <span *ngIf="element?.confidence_score == 'very high' || element?.confidence_score == 'high'" matTooltip='{{element?.confidence_score | titlecase}} confidence'
            [matTooltipClass]="{ 'small-tooltip text-black': true }"><i class="fa-sharp fa-solid fa-shield-check ml-1" style="color: #2E93A1;"></i></span>
                   <span *ngIf="element?.median_salary == 'N/A'"  matTooltip='We’re actively expanding salary coverage for this role. More data will be available as market signals strengthen.'
                  [matTooltipClass]="{ 'small-tooltip text-black': true }" style="font-family: Arial, sans-serif;">&mdash;</span>

                </td>
            </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedSeniorityColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedSeniorityColumns;"></tr>
            </table>
            <div *ngIf="currentseniority == null || currentseniority.length == 0">
                <p class="text-center small p-5">No Data Available</p>
            </div>
        </div>


    </div>
  </div>

  <!-- <div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCount > 10">
    <ngb-pagination [collectionSize]="totalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSize" rotate="false" (pageChange)="setPage($event)" [(page)]="currentPage" [ellipses]="false">
      <ng-template ngbPaginationPrevious> Previous </ng-template>
      <ng-template ngbPaginationNext> Next </ng-template>
    </ngb-pagination>
  </div> -->
<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
